import { API_URL } from "config";
import Notify from "config/notify";
import Http from "util/https";

/**
 * アップロードした在庫数CSVを反映
 * @param process_id 仕入先コード
 */
export default async function uploadCountCsv(process_id: string) {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/stock/csv/update`;
  const response = await http.post(url, { process_id });
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "更新が完了しました",
      confirmLabel: "OK",
      actionsPosition: "end",
    });
  }
}
